export default {"src":"/_next/static/media/Bundle.1fceab13.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};